import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import PeriodoForm from './PeriodoForm';
import {
  get,
  save,
  fetchFormDatas,
} from '../../../redux/actions/periodoActions';
import {
  remove as removeMateriaPeriodo,
} from '../../../redux/actions/materiaPeriodoActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import Confirm from '../../../shared/components/Confirm';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import { dateTimeString } from '../../../helpers/dateFormat';

class PeriodoFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this.handleOnFilterChange = this.handleOnFilterChange.bind(this);
    this.handleOnSubjectChange = this.handleOnSubjectChange.bind(this);
    this.handleDeleteMateriaPeriodo = this.handleDeleteMateriaPeriodo.bind(this);
  }

  componentDidMount() {
    this.fetchDatasList();
    this.fetchCurrentRecord();
  }

  fetchCurrentRecord = () => {
    const { id, history } = this.props;
    this.setState({
      loading: true,
    });
    if (id) {
      get(id, {
        onSuccess: (dto) => {
          const periodo = {
            ...dto,
            anhoLectivo: {
              value: dto.anhoLectivoId,
              label: `${dto.anho}`,
            },
          };

          this.setState({ periodo, loading: false });
        },
        onError: (error) => {
          if (error && error.status === 404) {
            createErrorMessage('El periodo no existe');
            history.push('/pages/periodos');
          } else {
            createErrorMessage('Error al intentar cargar los datos del periodo');
          }

          this.setState({
            loading: false,
          });
        },
      });
    } else {
      this.setState({
        periodo: {
          id: 0,
          fecha: new Date().toISOString(),
        },
        loading: false,
      });
    }
  }

  fetchDatasList = () => {
    this.setState({
      loading: true,
    });
    fetchFormDatas({
      onSuccess: (d) => {
        this.setState({
          aniosLectivos: d.aniosLectivos,
          carreras: d.carreras,
          loading: false,
        });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
        this.setState({
          loading: false,
        });
      },
    });
  }

  handleSubmit = (values) => {
    this.setState({
      loading: true,
    });

    const {
      anhoLectivo: { value: anhoLectivoId },
      finCalificarTareas,
      finEditarPlaneamiento,
    } = values;

    const params = {
      ...values,
      finCalificarTareas: dateTimeString(finCalificarTareas),
      finEditarPlaneamiento: dateTimeString(finEditarPlaneamiento),
      anhoLectivoId,
    };
    const { history } = this.props;
    save(params, {
      onSuccess: () => {
        this.setState({
          loading: false,
        });
        createSuccessMessage('Periodo guardado exitosamente');
        history.push('/pages/periodos');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar el periodo');
        }
        this.setState({
          loading: false,
        });
      },
    });
  }

  handleDeleteMateriaPeriodo = (materiaPeriodo) => {
    const name = `${materiaPeriodo.materia}`;
    Confirm({
      title: 'Quitar materia de periodo',
      question: `Estás seguro que deseas quitar la materia ${name} de este periodo?`,
      yesLabel: 'Si, Quitar',
      noLabel: 'No, Volver',
      onConfirm: () => {
        this.setState({
          loading: true,
        });

        removeMateriaPeriodo(materiaPeriodo.id,
          {
            onSuccess: () => {
              createSuccessMessage('Materia quitada exitosamente');
              this.fetchDatasList();
              this.fetchCurrentRecord();
              this.setState({
                loading: false,
              });
            },
            onError: (error) => {
              this.setState({
                loading: false,
              });
              if (error && error.status === 404) {
                createErrorMessage('La materia no existe');
              } else {
                createErrorMessage('Error al intentar quitar la materia del periodo');
              }
            },
          });
      },
    });
  };


  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    const { periodo } = this.state;
    this.setState({
      [idKey]: value.value,
      periodo: { ...periodo, [objectKey]: value },
    });
  }

  handleOnSubjectChange = (objectKey, idKey, value) => {
    const { periodo } = this.state;
    const profesor = `${value.nombre} ${value.apellido}`;
    let { interventorId, interventor } = periodo;

    if (!interventorId) {
      interventorId = value.usuarioId;
      interventor = { value: interventorId, label: profesor };
    }
    this.setState({
      [idKey]: value.value,
      periodo: {
        ...periodo,
        [objectKey]: value,
        profesor,
        interventor,
        interventorId,
      },
    });
  }

  render() {
    const { id, history } = this.props;
    const {
      periodo,
      aniosLectivos,
      carreras,
      loading,
    } = this.state;
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nuevo'} periodo
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la informaci&oacute;n del periodo
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!aniosLectivos && loading
              ? <LoadingSpinner />
              : (
                <PeriodoForm
                  {...periodo}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={periodo}
                  history={history}
                  aniosLectivos={aniosLectivos}
                  carreras={carreras}
                  onFilterChanges={this.handleOnFilterChange}
                  onSubjectChanges={this.handleOnSubjectChange}
                  handleDeleteMateriaPeriodo={this.handleDeleteMateriaPeriodo}
                  enableReinitialize
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

PeriodoFormContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default PeriodoFormContainer;
